import { Search } from "@material-ui/icons";
import { Fab, Grid, TextField, Tooltip } from "@mui/material";
import Select from "components/select/Select";
import { ALL_OPTION } from "constant";
import { useFormik } from "formik";
import { useGetListProvince } from "service/query/common.query";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

const QueueFilter = ({ onSubmit }) => {
  const { data: listProvince } = useGetListProvince();

  const formik = useFormik({
    initialValues: {
      subOrg: ALL_OPTION.value,
      name: "",
      code: "",
    },
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Select
            {...getSelectFieldProps(formik, "subOrg")}
            label="Bộ phận"
            options={listProvince?.map((item) => ({
              label: item.name,
              value: item.code,
            }))}
            showAllOption
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            {...getTextFieldProps(formik, "name")}
            label="Tên hàng đợi"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            {...getTextFieldProps(formik, "code")}
            label="Mã hàng đợi"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Tooltip title="Tìm kiếm">
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default QueueFilter;
